<div id="redemptionPopUp" *ngIf="enableRedirection && !isRegistered; else isRegisteredPopup">
  <div class="modal-header">
    <div class="modal-title">{{redemptionTitleTxt}}</div>
    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="close()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    {{redemptionTxt}}
    <br><br>
    <div class="row" id="termsConditions">
       <div class="col-1 col-sm-1 col-lg-1 col-md-1">
        <div class="checkbox checkbox-primary checkbox-terms">
          <mat-checkbox id='termscheckbox' class="padding-checkbox" #termsCheckbox (change)="termsChecked($event)"></mat-checkbox>
          <label for="termsCheckbox"></label>
        </div>
      </div>
      <div class= "col-11 col-sm-11 col-lg-11 col-md-11">
        <div class="termsConditions">
          {{redemptionAgreeTxt}}
            <a class="terms_conditions" tabindex="0" target="_blank"
              href="{{termsAndConditionUrl}}" rel="noopener">
              <span class="link_color">{{redemptionStreamingTerms}}</span>
            </a>
            {{redemptionBeforeUsingTxt}}
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer popup_btnbox bottom_aligner">
    <button type='button' class='primary_btn' id='go-to-netflix-btn' (click)="goToNetflix()"
      [disabled]="!goToButtonEnabled">{{redemptionGotoTxt}}</button>
  </div>
</div>

<ng-template #isRegisteredPopup>
  <div *ngIf="enableRedirection && isRegistered; else careReminderPopup">
    <div id="redemptionPopUp1">
      <!-- Title -->
      <div class="modal-header">
        <div class="modal-title">
          <div class="row pb-5">
            <img class="netflixRedirection" src="{{redemptionSrcImage}}" alt={{redemptionAltText}}>
          </div>
          <div class="row">
            <div>{{isRegisteredTxt1}}</div>
          </div>
          <div class="row">
            <a>{{isRegisteredTxt2}}</a>
          </div>
        </div>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="close()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <!-- Body -->
      <div class="modal-body">
        <div *ngIf="isNetFlixSoc; else huluBody">
          <div class="row pb-2">
            <a>{{isRegisteredTxt3}}</a>
          </div>
          <div class="row">
            <a tabindex="0" target="_blank" href="{{redirectionLink}}" rel="noopener">
              <span class="link_color">{{isRegisteredTxt4}}</span>
            </a>
          </div>
        </div>
        <ng-template #huluBody>
          <div class="row">
            <button type='button' class='primary_btn' id='go-to-hulu-btn' (click)="goToHulu()"
              >{{redemptionGotoTxt}}</button>
          </div>
        </ng-template>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #careReminderPopup>
  <div id="redemptionPopUp2">
    <div class="modal-header">
      <div class="modal-title">{{careReminderTitleTxt}}</div>
      <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="close()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div>
        <a> {{careReminderTxt}}</a>
      </div>
    </div>
  </div>
</ng-template>